import { Create } from "react-admin";
import { ProgramForm } from "./form";

export const ProgramCreate = () => (
  <Create title="Create program" redirect="list">
    <ProgramForm title="title" desc="description" selectInput="type.id" />
  </Create>
);
